import spreadIntoContainer from 'functions/spread-image';

export default class bxSlideshow {
    constructor(context) {
        this.context = context;

        // Константы
        this.BX_SETTINGS = {
            adaptiveHeight: false,
            auto: true,
            pause: 6000,
            tickerHover: true,
            slideSelector: '.slide',
            responsive: true,
            mode: 'fade',
            onSliderLoad: index => this.slideChangeHandler(index),
            onSlideBefore: ($slide, old, index) => this.slideChangeHandler(index),
        };

        this.$ = window.jQuery;

        // Если есть jQuery, то инициализируем слайдер
        if (typeof this.$ === 'function') {
            this.$(this.initBxSlider.bind(this));
        }

        window.addEventListener('load', this.initVideoOverlays());

        this.initResize();
    }

    // Перехват кликов на видео
    initVideoOverlays() {
        const container = this.context.querySelector('.video-slide');
        const iframe = container.firstElementChild;

        if (iframe && iframe.tagName === 'IFRAME') {
            iframe.src += '?autoplay=1&mute=1';
        }
    }

    // Инициализирует bxSlider если слайдов больше одного
    initBxSlider() {
        const slider = this.context.querySelector('.slider');

        if (slider.getAttribute('data-slides-count') > 1) {
            this.bxSlider = this.$(slider).bxSlider(this.BX_SETTINGS);
        } else {
            const img = this.context.querySelector('.slide img');
            spreadIntoContainer(img);
        }

        // типа загрузились, показываем картинки )
        [].forEach.call(this.context.querySelectorAll('.slide img'), img => {
            // eslint-disable-next-line no-param-reassign
            img.style.opacity = 1;
        });
    }

    // Ресайзит картинки, чтобы всегда сохранялся верный аспект
    initResize() {
        window.addEventListener('resize', () => {
            const visibleImg = this.context.querySelector('.slide[aria-hidden="false"] img');

            spreadIntoContainer(visibleImg);
        });
    }

    slideChangeHandler(index = 0) {
        const img = this.context.querySelectorAll('.slide img')[index];

        setTimeout(() => spreadIntoContainer(img), 0); // жду пока картинка станет видимой
    }

    // Останавливает автосмену на слайдере
    stopSliderAutoplay() {
        if (this.bxSlider) {
            this.bxSlider.stopAuto();
        }
    }
}
